import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // LocalStorage for persistence
import { persistReducer, persistStore } from "redux-persist";
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import appStateSlice from "./features/appStateSlice";
import storeIdStateSlice from "./features/storeIdStateSlice";
import storeDeleteStateSlice from "./features/storeDeleteStateSlice";
import authSlice from "./features/authSlice"; // Import auth slice

// Persist Configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Persist only auth state
};

// Combine reducers
const rootReducer = combineReducers({
  appState: appStateSlice,
  storeIdState: storeIdStateSlice,
  storeDeleteState: storeDeleteStateSlice,
  auth: authSlice, // Add auth slice
});

// Apply persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Persistor
export const persistor = persistStore(store);

// Types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
